"use strict";
var _a;
exports.__esModule = true;
exports.HelpLinksMap = void 0;
var enums_1 = require("./enums");
exports["default"] = {
    segmentDDApiKey: 'L3UWqZFYa0jF2PtgpEsKod2WtZet4Zvr',
    segmentCaviarApiKey: 'ctJaPszdHTeUJeaiMgfH5IFNFxo9gTcq'
};
// tslint:disable:max-line-length
exports.HelpLinksMap = (_a = {},
    _a[enums_1.RiskClientAppName.Dasher] = 'https://help.doordash.com/dashers/s/article/How-Do-I-Verify-My-Account',
    _a[enums_1.RiskClientAppName.Default] = 'https://help.doordash.com/consumers/s/article/How-do-I-verify-my-account',
    _a[enums_1.RiskClientAppName.MerchantPortal] = 'https://help.doordash.com/merchants/s/article/How-do-I-verify-my-account-when-accessing-the-Merchant-Portal',
    _a[enums_1.RiskClientAppName.MerchantMobile] = 'https://help.doordash.com/merchants/s/article/How-do-I-verify-my-account-when-accessing-the-Merchant-Portal',
    _a);
